export enum PageTab {
  Details = 'details',
  Team = 'team',
  FeeSchedule = 'fee-schedule',
  Conflicts = 'conflicts',
  Policies = 'policies',
  Discount = 'discount'
}
